var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2C10.4477 2 10 2.44772 10 3L9.74342 3C8.22827 3 7 4.22827 7 5.74342C7 6.92427 7.75562 7.97263 8.87587 8.34605L12.4917 9.55132C12.7952 9.65251 13 9.93659 13 10.2566C13 10.6672 12.6672 11 12.2566 11H11H10C9.44772 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 11.6569 8.34315 13 10 13C10 13.5523 10.4477 14 11 14C11.5523 14 12 13.5523 12 13H12.2566C13.7717 13 15 11.7717 15 10.2566C15 9.07573 14.2444 8.02737 13.1241 7.65395L9.50833 6.44868C9.20476 6.34749 9 6.06341 9 5.74342C9 5.33284 9.33284 5 9.74342 5H11H12C12.5523 5 13 5.44772 13 6C13 6.55228 13.4477 7 14 7C14.5523 7 15 6.55228 15 6C15 4.34315 13.6569 3 12 3C12 2.44772 11.5523 2 11 2ZM8.20711 16.7071C8.59763 16.3166 8.59763 15.6834 8.20711 15.2929C7.81658 14.9024 7.18342 14.9024 6.79289 15.2929L4.29289 17.7929C3.90237 18.1834 3.90237 18.8166 4.29289 19.2071L6.79289 21.7071C7.18342 22.0976 7.81658 22.0976 8.20711 21.7071C8.59763 21.3166 8.59763 20.6834 8.20711 20.2929L7.41421 19.5H17C17.5523 19.5 18 19.0523 18 18.5C18 17.9477 17.5523 17.5 17 17.5H7.41421L8.20711 16.7071Z",
    fill: "#E5E9EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIn);
export default __webpack_public_path__ + "static/media/dollar-in.213bf8cfce552601ff6b3fa507e28026.svg";
export { ForwardRef as ReactComponent };